import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const matchListMixin = {
  data() {
    return {
      totalItems: 0,
      items: [],
      selectedPage: 0,
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      selectedMatchColumns: ['branch', 'type', 'docNo', 'acctNo', 'fund', 'suffix', 'tranDate', 'curr', 'netAmt', 'osBal'],
      matchColumns: [
        { text: 'Branch', value: 'branch' },
        { text: 'Type', value: 'type' },
        { text: 'Doc No.', value: 'docNo' },
        { text: 'Acct No.', value: 'acctNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Suffix', value: 'suffix' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Currency', value: 'curr' },
        { text: 'Net Amount', value: 'netAmt' },
        { text: 'O/S Balance', value: 'osBal' }
      ],
      totalMatchDetItems: 0,
      matchDetItems: [],
      matchDetSelectedPage: 0,
      matchDetpagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      selectedMatchDetailColumns: ['tranDate', 'polNo', 'branch', 'docNo', 'fund', 'suffix', 'curr', 'rsMatchAmt', 'rsOsBal', 'rsLocOSBal', 'detail', 'action'],
      matchDetailColumns: [
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Branch', value: 'branch' },
        { text: 'Type', value: 'type' },
        { text: 'Doc No.', value: 'docNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Suffix', value: 'suffix' },
        { text: 'Curr', value: 'curr' },
        { text: 'Match Amount', value: 'rsMatchAmt' },
        { text: 'OS Bal', value: 'rsOsBal' },
        { text: 'Local OS Balance', value: 'rsLocOSBal' },
        { text: 'Detail', value: 'detail' },
        { text: 'Action', value: 'action' }
      ]
    }
  },
  computed: {
    listMatch() {
      let result = []
      for (const selectedMatchColumn of this.selectedMatchColumns) {
        let findCol = this.matchColumns.find(a => selectedMatchColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    matchDetailListMatch() {
      let result = []
      for (const selectedMatchDetailColumn of this.selectedMatchDetailColumns) {
        let findCol = this.matchDetailColumns.find(a => selectedMatchDetailColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    'pagination': function (value) {
      if (this.isFiltered) {
        this.performSearch(false)
      }
    },
    'matchDetPagination': function (value) {
      // this.performSearch(false)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
